module.exports = __webpack_public_path__ + "static/media/logoutv2.f769be08.svg";